<template>
    <div class="row d-flex justify-content-center">
        <div class="row d-flex justify-content-center" style="margin-top: 30px;">Ingrese sus datos para iniciar sesión.</div>
        <div class="col-md-8 mt-5">
            <form @submit.prevent="onSubmit">
                <div class="form-group mb-3">
                    <label><strong>Email</strong></label>
                    <input type="email" class="form-control form-control-lg" v-model="user.email" />
                </div>

                <div class="form-group mb-3">
                    <label><strong>Contraseña</strong></label>
                    <input type="password" class="form-control form-control-lg" v-model="user.password" />
                </div>

                <div class="d-grid">
                    <input type="submit" class="btn btn-primary btn-lg btn-block" value="Entrar"/>
                </div>
            </form>
            <br>
            <b-card header="Solicitar datos de acceso" class="text-center">
                <b-card-text>Para obtener sus datos de acceso debe escribir a la Dra. Adriana Ortiz al correo: difraco.admon@gmail.com, indicando su interés en usar DIFRACO.</b-card-text>
            </b-card>
            <br>
        </div>
    </div>
</template>

<script>
import firebase from "firebase/compat/app";
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import 'firebase/compat/analytics';

export default {
  data() {
    return {
      user: {
        email: '',
        password: ''
      }
    };
  },
  methods: {
    onSubmit() {
      firebase.auth()
      .signInWithEmailAndPassword(this.user.email, this.user.password).then(() => {
        console.log('Usuario autenticado.');
        //alert('Usuario autenticado.');
        this.$router.push('/usuario')
       })
      .catch((err) => {
         console.log(err);
         alert('Error de autenticación. Verifique los datos de acceso y vuelva a intentarlo.')
      });
    }
  }
};
</script>
